exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-secondary {\n  background: #149fba;\n}\n.w-100 {\n  width: 100%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/rewards/rewards.component.less
// module id = ../../../../../src/app/rewards/rewards.component.less
// module chunks = 1